import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import Page from "src/components/Page";
import Home from "./Home";


function Index(props) {
  localStorage.removeItem("@storeAuctionLot");

  


  return (
    <>
      <Page  >
        <Home />
      </Page>
    </>
  );
}

export default Index;
